import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useCallback } from 'react';
var IN_VIEW_THRESHOLD = 0.5;
export function isInView(el) {
  var rect = el.getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;
  var verticalInView = rect.top >= 0 && rect.top < windowHeight || rect.bottom > 0 && rect.bottom <= windowHeight || rect.top < 0 && rect.bottom > windowHeight * IN_VIEW_THRESHOLD;
  var horizontalInView = rect.left >= 0 && rect.left < windowWidth || rect.right > 0 && rect.right <= windowWidth || rect.left < 0 && rect.right > windowWidth * IN_VIEW_THRESHOLD;
  return verticalInView && horizontalInView;
}
var WithVisibilityTrigger = function WithVisibilityTrigger(_ref) {
  var children = _ref.children,
    cb = _ref.cb,
    enabled = _ref.enabled,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? IN_VIEW_THRESHOLD : _ref$threshold,
    _ref$once = _ref.once,
    once = _ref$once === void 0 ? true : _ref$once;
  var elementRef = useRef(null);
  var callbackRef = useRef(cb); // Store callback in ref to prevent unnecessary observer recreations
  var hasTriggeredRef = useRef(false);

  // Update callback ref when cb changes
  useEffect(function () {
    callbackRef.current = cb;
  }, [cb]);
  var handleIntersection = useCallback(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && elementRef.current) {
        if (once && hasTriggeredRef.current) return;
        callbackRef.current(elementRef.current);
        hasTriggeredRef.current = true;
      }
    });
  }, [once]);
  useEffect(function () {
    if (!enabled || !elementRef.current) return;

    // Reset trigger state when enabled changes
    hasTriggeredRef.current = false;
    var observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: threshold,
      rootMargin: '10px' // Add some margin to trigger slightly before the element is in view
    });
    observer.observe(elementRef.current);
    return function () {
      observer.disconnect();
    };
  }, [enabled, threshold, handleIntersection]);
  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef,
    "data-enabled": enabled,
    className: "w-full"
  }, children);
};
export default WithVisibilityTrigger;